"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorDialogComponent = ErrorDialogComponent;
const React = __importStar(require("react"));
const Elements = __importStar(require("@genesys/client-core/lib/elements"));
const clipboard = __importStar(require("@genesys/client-core/lib/browsertools/clipboard"));
const WindowUtils = __importStar(require("@genesys/client-core/lib/window-utils"));
const LanguageTexts = __importStar(require("@genesys/shared/lib/language-texts"));
function ErrorDialogComponent(props) {
    return React.createElement(InnerErrorDialog, Object.assign({}, props));
}
function InnerErrorDialog({ exceptionReport, showDetails, toggleErrorDetails, textTranslator }) {
    const exceptionText = `${exceptionReport.content}

${exceptionReport.systemInformation}
`;
    return (React.createElement(Elements.FixedOverlay, null,
        !showDetails && (React.createElement(Elements.ErrorDialogContainer, null,
            React.createElement(Elements.ContainerWithWhiteBorder, null,
                React.createElement(Elements.DialogHeaderContainer, null,
                    React.createElement("h2", null, "Exception")),
                React.createElement(Elements.DialogBodyContainer, null,
                    React.createElement(Elements.ErrorPanelContainer, null,
                        React.createElement("div", null,
                            React.createElement("img", { width: "100", src: "/assets/images/error_icon.png" })),
                        React.createElement("div", null,
                            React.createElement(Elements.H2, null, "An exception occured"),
                            React.createElement("p", null, exceptionReport.title))),
                    React.createElement(Elements.ButtonContainer, null,
                        React.createElement(Elements.StandardButton, { onClick: toggleErrorDetails }, textTranslator(LanguageTexts.edviewreport())),
                        React.createElement(Elements.StandardButton, { onClick: () => WindowUtils.reload() }, textTranslator(LanguageTexts.edreload()))))))),
        showDetails && (React.createElement(Elements.TextDialogContainer, { containerWidth: 800 },
            React.createElement(Elements.ContainerWithWhiteBorder, null,
                React.createElement(Elements.DialogHeaderContainer, null,
                    React.createElement("h2", null),
                    React.createElement("span", { onClick: toggleErrorDetails }, "X")),
                React.createElement(Elements.DialogBodyContainer, null,
                    React.createElement(Elements.ReadOnlyTextArea, { disabled: true, value: exceptionText, containerHeight: 500 }),
                    React.createElement(Elements.ButtonContainer, null,
                        React.createElement(Elements.StandardButton, { onClick: () => clipboard.toClipboard(exceptionText) }, textTranslator(LanguageTexts.edcopyexception())),
                        React.createElement(Elements.StandardButton, { onClick: toggleErrorDetails }, "Close"))))))));
}
//# sourceMappingURL=error-dialog-component.js.map